import { createFileRoute } from '@tanstack/react-router'
import { parseFocus, VisitTypesTab, type VisitTypeFilter } from '@/features/settings'

interface Search {
  q?: string
  show?: VisitTypeFilter
  focus?: string
}

/**
 * C-06 Visit types; `q`, `show` and `focus` in the URL, defaults stripped (Frontend §6.1). A `focus` from a C-05
 * arrow drops the filters first, so the row is on screen (the mockup's `reveal`).
 */
export const Route = createFileRoute('/_authed/clinics/$clinicId/settings/booking/visit-types')({
  validateSearch: (raw: Record<string, unknown>): Search => {
    const focus = parseFocus(raw)
    if (focus.focus) return focus
    return {
      ...(typeof raw.q === 'string' && raw.q !== '' && { q: raw.q.slice(0, 100) }),
      ...((raw.show === 'on' || raw.show === 'off') && { show: raw.show }),
    }
  },
  component: function VisitTypesRoute() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    // The root passes raw params through, so the filters are dropped here too while a row is focused.
    const focused = search.focus !== undefined
    return (
      <VisitTypesTab
        q={focused ? '' : (search.q ?? '')}
        show={focused ? 'all' : (search.show ?? 'all')}
        focus={search.focus}
        onSearch={(next) => {
          void navigate({
            search: (prev) => {
              const merged = { ...prev, ...next }
              return {
                ...(merged.q ? { q: merged.q } : {}),
                ...(merged.show && merged.show !== 'all' ? { show: merged.show } : {}),
              }
            },
            replace: true,
          })
        }}
      />
    )
  },
})
